import React from 'react';
import MainSlider from '../containers/mainSlider.js';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import InstructionBoxContainer from '../containers/InstructionBoxContainer';
import AlerContainer from '../containers/AlertContainer';
const App = () => { 
    return (<div>   
        <Row>
            <InstructionBoxContainer />          
            <AlerContainer/>
            <Col md={12}>
                <MainSlider nextSlide={""} previousSlide={""} />
            </Col>
        </Row>

    </div>
    )
}
export default App
